import { render, staticRenderFns } from "./manualApproveFcp.vue?vue&type=template&id=70969250&lang=pug"
import script from "./manualApproveFcp.vue?vue&type=script&lang=js"
export * from "./manualApproveFcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports